module.exports = __webpack_public_path__ + "img/header.159a9875.png";